import {
  Code,
  MagnifyingGlass,
  Robot,
  ChartBar,
  TextAa,
  TextT,
  Paragraph,
  Lock,
  QrCode,
  Browsers,
  BracketsCurly,
  Binary,
  Fingerprint,
  Hash,
} from "@phosphor-icons/react";

export const CATEGORIES = [
  { id: "all", label: "All Tools" },
  { id: "seo", label: "SEO" },
  { id: "text", label: "Text" },
  { id: "generators", label: "Generators" },
  { id: "developer", label: "Developer" },
  { id: "web", label: "Web Utilities" },
];

export const TOOLS = [
  {
    slug: "meta-tag-generator",
    name: "Meta Tag Generator",
    short: "Generate clean HTML meta & Open Graph tags for better sharing and SEO.",
    category: "seo",
    icon: Code,
    code: "SEO-01",
  },
  {
    slug: "serp-preview",
    name: "SERP Preview Tool",
    short: "See exactly how your page appears in Google search results before you publish.",
    category: "seo",
    icon: MagnifyingGlass,
    code: "SEO-02",
  },
  {
    slug: "robots-txt-generator",
    name: "Robots.txt Generator",
    short: "Build a valid robots.txt file to control how crawlers index your site.",
    category: "seo",
    icon: Robot,
    code: "SEO-03",
  },
  {
    slug: "keyword-density",
    name: "Keyword Density Checker",
    short: "Analyze content and surface top keywords with frequency and density percentages.",
    category: "seo",
    icon: ChartBar,
    code: "SEO-04",
  },
  {
    slug: "word-counter",
    name: "Word Counter",
    short: "Count words, characters, sentences, paragraphs and estimated reading time live.",
    category: "text",
    icon: TextAa,
    code: "TXT-01",
  },
  {
    slug: "case-converter",
    name: "Case Converter",
    short: "Convert text between UPPER, lower, Title, camelCase, snake_case and more.",
    category: "text",
    icon: TextT,
    code: "TXT-02",
  },
  {
    slug: "lorem-ipsum",
    name: "Lorem Ipsum Generator",
    short: "Generate placeholder paragraphs, sentences or words for mockups and layouts.",
    category: "generators",
    icon: Paragraph,
    code: "GEN-01",
  },
  {
    slug: "password-generator",
    name: "Password Generator",
    short: "Create strong, random passwords with full control over length and characters.",
    category: "generators",
    icon: Lock,
    code: "GEN-02",
  },
  {
    slug: "qr-code-generator",
    name: "QR Code Generator",
    short: "Turn any URL or text into a crisp, downloadable QR code in seconds.",
    category: "generators",
    icon: QrCode,
    code: "GEN-03",
  },
  {
    slug: "bulk-url-opener",
    name: "Bulk URL Opener",
    short: "Paste a list of URLs and open them all in new tabs with a single click.",
    category: "web",
    icon: Browsers,
    code: "WEB-01",
  },
  {
    slug: "json-formatter",
    name: "JSON Formatter",
    short: "Beautify, minify and validate JSON with instant error reporting.",
    category: "developer",
    icon: BracketsCurly,
    code: "DEV-01",
  },
  {
    slug: "base64",
    name: "Base64 Encoder / Decoder",
    short: "Encode text to Base64 or decode it back, with full UTF-8 support.",
    category: "developer",
    icon: Binary,
    code: "DEV-02",
  },
  {
    slug: "uuid-generator",
    name: "UUID Generator",
    short: "Generate cryptographically random v4 UUIDs in bulk, ready to copy.",
    category: "developer",
    icon: Fingerprint,
    code: "DEV-03",
  },
  {
    slug: "hash-generator",
    name: "Hash Generator",
    short: "Compute SHA-1, SHA-256, SHA-384 and SHA-512 hashes of any text.",
    category: "developer",
    icon: Hash,
    code: "DEV-04",
  },
];

export const getTool = (slug) => TOOLS.find((t) => t.slug === slug);
